import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faPlus } from "@fortawesome/free-solid-svg-icons";

import { notify, getValueFromLocalStorageFunc } from "../../../services/functions";

import { ToastContainer } from "react-toastify";

const ModalImportDevice = (props) => {
  const {
    par_show,
    title,
    status,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    row,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tipeMenu,
    par_statusLoader,
    outChange,
  } = props;

  const [show, setShow] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [file, setFile] = useState<File | null>(null);

  const refFileInput = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setShow(par_show ?? false);
    setLoaderStatus(par_statusLoader);
  }, [par_show, par_statusLoader]);

  const handleHide = () => {
    setShow(false);
    outChange(false);
  };

  // Handle Download Template
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/template/template_kawal.xlsx`;
    link.download = "template_kawal.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Handle File Upload Change
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]; // Get the first selected file
    if (file) {
      // Only allow .xlsx files
      const isExcelFile =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isExcelFile) {
        setFile(file);
      } else {
        notify(
          "error",
          "Please upload a valid Excel (.xlsx) file.",
          "TOP_CENTER",
        );
      }
    }
  };

  const handleSubmit = () => {
    if (!file) {
      notify("error", "Please select a file to upload.", "TOP_CENTER");
      return;
    }

    const formData = new FormData();
    formData.append("excelFile", file); // Append the file to the form data with correct parameter name

    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const endpoint = "https://api-kawal.savas.co.id/api/v1/upload";

    setLoaderStatus(true); // Show loader while uploading

    // Custom file upload implementation matching the curl command
    fetch(endpoint, {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
        // Don't set Content-Type manually - browser will set it with boundary automatically
      },
      body: formData,
    })
      .then((response) => {
        setLoaderStatus(false); // Hide loader once the response is received

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
      })
      .then((result) => {
        if (result?.statusCode) {
          notify("error", result?.msg, "TOP_CENTER");
          return;
        }

        notify("success", "Your file was uploaded successfully!", "TOP_CENTER");
        setShow(false);
        outChange({
          tipe: "close_after_success_save",
          value: false,
          form: "create",
        });
      })
      .catch((error) => {
        setLoaderStatus(false);
        console.error("Upload error:", error);
        notify(
          "error",
          "An error occurred. Please try again later.",
          "TOP_CENTER",
        );
      });
  };

  return (
    <>
      {/* MODAL CREATE USER */}
      <Modal show={show} centered size="sm" backdrop={true} onHide={handleHide}>
        <Modal.Header
          className={`modalheader modal-header-global ${
            status === "Edit" ? "edit" : "create"
          }`}
        >
          <Modal.Title className={`dashboard-modal-title`}>
            {status === "Create" && (
              <>
                <FontAwesomeIcon
                  icon={faPlus}
                  className={`login-dropdown-icon`}
                  color={"darkgreen"}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 10,
                    zIndex: 0,
                    transform: `scale(1.5)`,
                  }}
                />
              </>
            )}

            <span className="login-icon-modal-title">{title}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex" }} className="row">
            {/* File Upload Section */}
            <Form.Group className="mb-1 col-12" controlId="file-upload">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Download Template
              </Form.Label>
              <Button
                onClick={handleDownloadTemplate}
                variant="outline-success"
              >
                <FontAwesomeIcon icon={faDownload} /> Download Template
              </Button>
              <br />
              <small className="form-text text-muted">
                Click to download the template for importing devices.
              </small>
            </Form.Group>

            <Form.Group className="mb-1 col-12" controlId="file-upload">
              <Form.Label className="mb-1 dash-modal-form-label required">
                Upload File
              </Form.Label>
              <Form.Control
                type="file"
                className="modal-input-placeholder"
                ref={refFileInput}
                onChange={handleFileChange}
                disabled={loaderStatus} // Disable input while loading
              />
              <small className="form-text text-muted">
                Only .xlsx files are allowed.
              </small>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loaderStatus}
          >
            Save
          </Button>
          <Button
            variant="secondary"
            onClick={handleHide}
            disabled={loaderStatus}
          >
            Close
          </Button>
        </Modal.Footer>

        <ToastContainer draggable pauseOnHover />
      </Modal>
    </>
  );
};

export default ModalImportDevice;
